// Order status — faithful port of flutter_client lib/enums/order_status.dart.
// Values are BIT FLAGS, not sequential. Do not reorder or renumber.

export const OrderStatus = {
  Created: 0,
  Accepted: 1,
  Rejected: 2,
  CarArrived: 4,
  ClientOnBoard: 8,
  Completed: 16,
  CarNotFound: 32,
  PreOrder: 64,
  Paid: 128,
} as const;

export type OrderStatusValue = (typeof OrderStatus)[keyof typeof OrderStatus];

export function orderStatusFromInt(value: number | null | undefined): OrderStatusValue {
  switch (value) {
    case 0:
      return OrderStatus.Created;
    case 1:
      return OrderStatus.Accepted;
    case 2:
      return OrderStatus.Rejected;
    case 4:
      return OrderStatus.CarArrived;
    case 8:
      return OrderStatus.ClientOnBoard;
    case 16:
      return OrderStatus.Completed;
    case 32:
      return OrderStatus.CarNotFound;
    case 64:
      return OrderStatus.PreOrder;
    case 128:
      return OrderStatus.Paid;
    default:
      return OrderStatus.Created;
  }
}
